import type { ReactNode } from 'react';
import { SignUpButton, TalkToFoundersButton } from '../CTAButtons';
import { HeroLabel } from '../ds';
import { ProductHeroStill } from './ProductHeroStill';

type ProductHeroStillProps = Parameters<typeof ProductHeroStill>[0];

type ProductHeroHeaderProps = {
  label: string;
  title: ReactNode;
  sub: string;
  note: string;
  still: ProductHeroStillProps;
};

export function ProductHeroHeader({ label, title, sub, note, still }: ProductHeroHeaderProps) {
  return (
    <header className="prod-hero band-dark">
      <div className="container reveal">
        <HeroLabel>{label}</HeroLabel>
        <h1>{title}</h1>
        <p className="prod-hero-sub">{sub}</p>
        <div className="prod-hero-ctas">
          <TalkToFoundersButton variant="primary" />
          <SignUpButton variant="ghost" />
        </div>
        <div className="prod-hero-note">{note}</div>
      </div>
      <div className="container prod-hero-media reveal d2">
        <ProductHeroStill {...still} />
      </div>
    </header>
  );
}
